import { Observable } from 'rxjs';

export abstract class AbstractTokenProvider {
  /** Returns promise.
   *  The Promise resolves with:
   *    token (string) when user is authenticated
   *    null or undefined when user is not authenticated
   */
  abstract getJwtToken(): Observable<string>;

  /** Returns object that contains information about the user */
  abstract getUserClaims(): { [claimKey: string]: string };
}
